// useUpdateTitle — mutation to rename a thread.
// Invalidates the thread list on success.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';
import { invalidateThreadList } from './invalidate';

function getClient() {
  return createApiClient({
    baseUrl: readEnv('VITE_API_BASE_URL') ?? '',
    auth: { getToken },
  });
}

async function updateTitle(threadId: string, title: string): Promise<void> {
  await getClient().request({
    method: 'PATCH',
    path: `/api/v1/sessions/${encodeURIComponent(threadId)}`,
    body: { title },
  });
}

export function useUpdateTitle() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ threadId, title }: { threadId: string; title: string }) =>
      updateTitle(threadId, title),
    onSuccess: () => {
      void invalidateThreadList(queryClient);
    },
  });

  return {
    updateTitle: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
